import React, { FC } from "react";
import { PulseLoader } from "react-spinners";

interface ColoredBorderSummaryCardsProp {
  title: string;
  borderColor: string;
  value: string | number;
  loading: boolean;
  loadingColor?: string;
}

const ColoredBorderSummaryCard: FC<ColoredBorderSummaryCardsProp> = ({
  borderColor,
  title,
  value,
  loading,
  loadingColor,
}) => {
  return (
    <div
      className={`p-4 bg-white rounded-md border-t-4 shadow-sm ${borderColor}`}
    >
      <h4 className="text-xs sm:text-sm md:text-base text-gray-600">{title}</h4>
      <p className="text-xl sm:text-2xl md:text-3xl font-semibold">
        {loading ? <PulseLoader size={12} color={loadingColor} /> : value}
      </p>
    </div>
  );
};

export default ColoredBorderSummaryCard;
